/* ==========================================================================
   Akel Beauty — shared behaviour
   Menu drawer, dispatch countdown, accordions, cart badge.
   ========================================================================== */

(function () {
  'use strict';

  /* ---------------------------------------------------------------- Drawer */

  function initMenuDrawer() {
    var drawer = document.querySelector('[data-menu-drawer]');
    var opener = document.querySelector('[data-menu-open]');
    if (!drawer || !opener) return;

    var lastFocused = null;

    function closeSubmenus() {
      drawer.querySelectorAll('[data-submenu-toggle]').forEach(function (toggle) {
        var panel = document.getElementById(toggle.getAttribute('aria-controls'));
        toggle.setAttribute('aria-expanded', 'false');
        if (panel) panel.hidden = true;
      });
    }

    drawer.querySelectorAll('[data-submenu-toggle]').forEach(function (toggle) {
      var panel = document.getElementById(toggle.getAttribute('aria-controls'));
      if (!panel) return;

      toggle.addEventListener('click', function () {
        var isOpen = toggle.getAttribute('aria-expanded') === 'true';
        toggle.setAttribute('aria-expanded', String(!isOpen));
        panel.hidden = isOpen;
      });
    });

    function open() {
      lastFocused = document.activeElement;
      drawer.hidden = false;
      opener.setAttribute('aria-expanded', 'true');
      document.body.style.overflow = 'hidden';
      var first = drawer.querySelector('a, button');
      if (first) first.focus();
    }

    function close() {
      drawer.hidden = true;
      opener.setAttribute('aria-expanded', 'false');
      document.body.style.overflow = '';
      closeSubmenus();
      if (lastFocused) lastFocused.focus();
    }

    opener.addEventListener('click', open);

    drawer.querySelectorAll('[data-menu-close]').forEach(function (btn) {
      btn.addEventListener('click', close);
    });

    // The drawer's own backdrop is the grid's empty second column.
    drawer.addEventListener('click', function (event) {
      if (event.target === drawer) close();
    });

    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape' && !drawer.hidden) close();
    });
  }

  /* ------------------------------------------------------------- Countdown */

  function initCountdowns() {
    var bars = document.querySelectorAll('[data-countdown-cutoff]');
    if (!bars.length) return;

    function pad(n) {
      return String(n).padStart(2, '0');
    }

    function tick() {
      var now = new Date();

      bars.forEach(function (bar) {
        var output = bar.querySelector('[data-countdown-output]');
        if (!output) return;

        var cutoffHour = parseInt(bar.getAttribute('data-countdown-cutoff'), 10);
        if (isNaN(cutoffHour)) return;

        var cutoff = new Date(now);
        cutoff.setHours(cutoffHour, 0, 0, 0);
        // Past today's cutoff: count down to tomorrow's.
        if (cutoff <= now) cutoff.setDate(cutoff.getDate() + 1);

        var remaining = Math.max(0, Math.floor((cutoff - now) / 1000));
        var hh = Math.floor(remaining / 3600);
        var mm = Math.floor((remaining % 3600) / 60);
        var ss = remaining % 60;

        output.textContent = pad(hh) + ':' + pad(mm) + ':' + pad(ss);
      });
    }

    tick();
    setInterval(tick, 1000);
  }

  /* ------------------------------------------------------------- Accordion */

  function initAccordions() {
    document.querySelectorAll('[data-accordion-trigger]').forEach(function (trigger) {
      var item = trigger.closest('.accordion__item');
      if (!item) return;
      var panel = item.querySelector('[data-accordion-panel]');
      var sign = trigger.querySelector('.accordion__sign');
      if (!panel) return;

      trigger.addEventListener('click', function () {
        var isOpen = trigger.getAttribute('aria-expanded') === 'true';
        trigger.setAttribute('aria-expanded', String(!isOpen));
        panel.hidden = isOpen;
        if (sign) sign.textContent = isOpen ? '+' : '−';
      });
    });
  }

  /* -------------------------------------------------------- Language form */

  function initLanguageSwitcher() {
    document.querySelectorAll('[data-lang-select]').forEach(function (select) {
      select.addEventListener('change', function () {
        try {
          window.localStorage.setItem('akel:locale-choice', select.value);
          if (window.location.hash) {
            window.sessionStorage.setItem('akel:locale-hash', window.location.hash);
          }
        } catch (e) {
          /* The form still works when storage is unavailable. */
        }
        if (select.form) select.form.submit();
      });
    });
  }

  /* ------------------------------------------------------------ Cart badge */

  function initCartBadge() {
    document.addEventListener('akel:cart:updated', function (event) {
      var count = event.detail && event.detail.item_count;
      if (typeof count !== 'number') return;
      document.querySelectorAll('[data-cart-count]').forEach(function (node) {
        node.textContent = count;
      });
    });
  }

  /* ------------------------------------------------------------------ Boot */

  function init() {
    initMenuDrawer();
    initCountdowns();
    initAccordions();
    initLanguageSwitcher();
    initCartBadge();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();

/* ==========================================================================
   Akel Beauty — automatic storefront language
   Uses the browser/device language once, then respects the shopper's choice.
   ========================================================================== */

(function () {
  'use strict';

  var STORAGE_KEY = 'akel:locale-choice';
  var HASH_STORAGE_KEY = 'akel:locale-hash';

  function init() {
    // Shopify's localization form does not carry the URL fragment. Restore it
    // after the locale redirect so links such as #avis keep their destination.
    try {
      var pendingHash = window.sessionStorage.getItem(HASH_STORAGE_KEY);
      if (pendingHash) {
        window.sessionStorage.removeItem(HASH_STORAGE_KEY);
        if (!window.location.hash) window.location.hash = pendingHash;
      }
    } catch (e) {
      /* Fragment restoration is optional when storage is unavailable. */
    }

    var form = document.querySelector('[data-locale-detect-form]');
    var configNode = document.querySelector('[data-locale-detect-config]');
    if (!form || !configNode) return;

    if (window.Shopify && window.Shopify.designMode) return;
    if (/bot|crawler|spider|slurp|bingpreview/i.test(navigator.userAgent || '')) return;

    // A previous automatic choice or a manual header choice always wins over
    // a later browser-language guess.
    var alreadyDecided = false;
    try {
      alreadyDecided = !!window.localStorage.getItem(STORAGE_KEY);
    } catch (e) {
      return; // storage blocked: stay silent rather than nag every page
    }
    if (alreadyDecided) return;

    var remember = function (value) {
      try {
        window.localStorage.setItem(STORAGE_KEY, value);
      } catch (e) {
        /* nothing useful to do */
      }
    };

    var config;
    try {
      config = JSON.parse(configNode.textContent);
    } catch (e) {
      return;
    }

    // Match the browser's ordered preferences against what the store publishes.
    // "fr-CA" should match a published "fr"; exact matches win.
    var preferred = (navigator.languages && navigator.languages.length
      ? navigator.languages
      : [navigator.language || '']
    ).map(function (tag) {
      return String(tag).toLowerCase();
    });

    var match = null;
    for (var i = 0; i < preferred.length && !match; i++) {
      var tag = preferred[i];
      var base = tag.split('-')[0];

      // Try the full regional tag first (for example fr-CA), then its base
      // language, then another published regional variant of that language.
      for (var j = 0; j < config.available.length; j++) {
        var candidate = config.available[j];
        var iso = String(candidate.iso).toLowerCase();
        if (iso === tag) {
          match = candidate;
          break;
        }
      }
      if (match) break;
      for (var k = 0; k < config.available.length; k++) {
        var baseCandidate = config.available[k];
        if (String(baseCandidate.iso).toLowerCase() === base) {
          match = baseCandidate;
          break;
        }
      }
      if (match) break;
      for (var m = 0; m < config.available.length; m++) {
        var regionalCandidate = config.available[m];
        if (String(regionalCandidate.iso).toLowerCase().split('-')[0] === base) {
          match = regionalCandidate;
          break;
        }
      }
    }

    // Unknown browser languages stay on the store's current/default locale.
    if (!match) return;

    remember(match.iso);
    if (String(match.iso).toLowerCase() === String(config.current).toLowerCase()) return;

    var localeInput = form.querySelector('[data-locale-detect-code]');
    if (!localeInput) return;
    localeInput.value = match.iso;

    try {
      if (window.location.hash) {
        window.sessionStorage.setItem(HASH_STORAGE_KEY, window.location.hash);
      }
    } catch (e) {
      /* The locale switch still works when storage is unavailable. */
    }

    if (typeof form.requestSubmit === 'function') {
      form.requestSubmit();
    } else {
      form.submit();
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();

/* ==========================================================================
   Akel Beauty — collection filters
   Submits Shopify's native filter form on change. Without JS the noscript
   Apply button does the same thing, so filtering never depends on scripting.
   ========================================================================== */

(function () {
  'use strict';

  function init() {
    var form = document.getElementById('CollectionFilterForm');
    if (!form) return;

    var submit = function () {
      // Drop empty fields so the URL stays readable and shareable.
      var data = new FormData(form);
      var params = new URLSearchParams();
      data.forEach(function (value, key) {
        if (String(value).trim() !== '') params.append(key, value);
      });
      var query = params.toString();
      window.location.href = window.location.pathname + (query ? '?' + query : '');
    };

    form.addEventListener('change', function (event) {
      if (event.target.type === 'number') return; // wait for blur on price
      submit();
    });

    form.querySelectorAll('input[type="number"]').forEach(function (input) {
      input.addEventListener('change', submit);
    });

    form.addEventListener('submit', function (event) {
      event.preventDefault();
      submit();
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
